import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLORS } from "rylak-common/src/constants";
import { TurnrCard, TurnrCardContent } from "./card/TurnrCard.jsx";
import classnames from "classnames";

export default function PageInformationCard(props) {
    const { icon, title, content, dotsMenu, iconProps, className, loading, contentMaxWidth = "1200px" } = props;

    return (
        <TurnrCard
            loading={loading}
            className={classnames("mb2", className)}
            style={{
                backgroundColor: "WHITE",
                color: "black",
                boxShadow: "none",
                border: "1px solid " + COLORS.GRAY,
            }}
        >
            <TurnrCardContent>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <FontAwesomeIcon
                        {...iconProps}
                        style={{
                            height: "20px",
                            width: "inherit",
                            marginRight: "10px",
                        }}
                        icon={icon}
                        color={COLORS.BROWN}
                    />
                    <h3
                        style={{
                            fontSize: "16px",
                            color: COLORS.BROWN,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gridGap: "10px",
                            }}
                        >
                            {title}
                            {dotsMenu && <div style={{ color: "black" }}>{dotsMenu}</div>}
                        </div>
                    </h3>
                </div>
                {content && (
                    <div
                        style={{
                            maxWidth: contentMaxWidth,
                            marginTop: "16px",
                            fontSize: "13px",
                        }}
                    >
                        {content}
                    </div>
                )}
            </TurnrCardContent>
        </TurnrCard>
    );
}
